export const MAX_VISIBLE_DOCUMENT_SIGNING_HISTORY_RECORDS = 5;
